import React from "react";
import { Card, CardBody, Col } from "reactstrap";

//Job Images
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import JobVacancyListing from "../../../../Jobs/JobListing/JobVacancyListing";

const RightSideContent = ({ details }) => {
  const jobs = useSelector((state) => state.jobs.data);
  const { companyId } = useParams();

  // filtering job by company id
  const filteredJobs = useMemo(() => {
    const actualJobsArray = jobs?.data;

    if (!actualJobsArray || !Array.isArray(actualJobsArray)) {
      console.log("Filter Status: No data array found in 'jobs'");
      return [];
    }

    return actualJobsArray.filter((job) => {
      // We are grabbing 'id' from the job object based on your latest log
      const targetId = job?.company.id;
      const urlId = companyId;

      // Check if they match
      const isMatch = String(targetId) === String(urlId);

      // This detailed log will show you the exact values and the result
      console.log(
        `🔍 MATCHING CHECK:
       - Job Title: ${job?.jobTitle || "Unknown"}
       - Job ID from Data: [${targetId}]
       - ID from URL Params: [${urlId}]
       - RESULT: ${isMatch ? "✅ MATCH FOUND" : "❌ NO MATCH"}`,
      );

      return isMatch;
    });
  }, [companyId, jobs]);

  return (
    <React.Fragment>
      <Col lg={8}>
        <Card className="ms-lg-4 mt-4 mt-lg-0">
          <CardBody className="p-4">
            <div className="mb-5">
              <h6 className="fs-17 fw-semibold mb-4">About Company Details</h6>
              {details?.data?.companyDetails ? (
                <div
                  className="text-muted ck-content"
                  dangerouslySetInnerHTML={{
                    __html: details.data.companyDetails,
                  }}
                />
              ) : (
                <p className="text-muted">No details available.</p>
              )}
            </div>

            <div>
              <h6 className="fs-17 fw-semibold mb-4">Current Opening Jobs</h6>

              <JobVacancyListing jobs={filteredJobs} />
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default RightSideContent;
